<template>
  <v-container fluid>
      <v-layout justify-center>
          <v-flex md12>
            <DataTableMainServer :datatable="tableServer" :on-success="successAction" :itemsAction="tableAction"
              :on-pagination="pagePagination" :on-search="getSearchPagePagination"/>
            <!--
              <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
            -->

          </v-flex>
      </v-layout>
      <AdscripcionMainDialog v-if="get_dialogMain.dialog && get_dialogMain.type !== 'update'" :model="adscripcion" :view="view" />
      <MainFormDialog v-if="get_dialogMain.dialog && get_dialogMain.type === 'update'" :fields="form" :model="object" :urls="url" :message="message" />

  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
// import DataTableMain from '@/components/tables/DataTableMain'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import AdscripcionMainDialog from '@/components/dialogs/adscripcion/AdscripcionMainDialog'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import { Permission } from '@/mixins/permissionMain'

export default {
  mixins: [Permission],
  data: () => ({
    tableServer: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'nomina.execute.create-adscripcion' }
        ],
        titles: [
          { text: 'Clave Empleado', value: 'empleado.cve_empleado', class: 'black--text' },
          { text: 'Empleado', value: 'empleado.NombreCompleto', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Plaza', value: 'plaza.nombre', class: 'black--text' },
          { text: 'Tipo Plaza', value: 'plaza.tipo_plaza.nombre', class: 'black--text' },
          { text: 'Puesto', value: 'plaza.puesto.nombre', class: 'black--text' },
          { text: 'Categoia', value: 'plaza.categoria.nombre', class: 'black--text' },
          { text: 'Nivel', value: 'plaza.nivel.nivel', class: 'black--text' },
          { text: 'Zona', value: 'plaza.zona.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateData', code: 'nomina-adscripciones.update' }
        ],
        totalData: 0,
        pagination: {}
      },
      footer: {
        paging: true
      }
    },
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'nomina.execute.create-adscripcion' }
        ],
        titles: [
          { text: 'Clave Empleado', value: 'empleado.cve_empleado', class: 'black--text' },
          { text: 'Empleado', value: 'empleado.NombreCompleto', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Plaza', value: 'plaza.nombre', class: 'black--text' },
          { text: 'Tipo Plaza', value: 'plaza.tipo_plaza.nombre', class: 'black--text' },
          { text: 'Puesto', value: 'plaza.puesto.nombre', class: 'black--text' },
          { text: 'Categoia', value: 'plaza.categoria.nombre', class: 'black--text' },
          { text: 'Nivel', value: 'plaza.nivel.nivel', class: 'black--text' },
          { text: 'Zona', value: 'plaza.zona.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateData', code: 'nomina-adscripciones.update' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: {},
    view: null,
    adscripcion: {},
    form: [],
    object: {},
    url: {},
    message: ''
  }),
  components: {
    // DataTableMain,
    DataTableMainServer,
    AdscripcionMainDialog,
    MainFormDialog
  },
  mounted () {
    // this.getUrl('POST/nomina/empleados-plazas/show')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.tableServer })
  },
  methods: {
    ...mapActions(['getUrlServices', 'postServicePaginationAction']),
    // *==========*==========*==========* Methods Table Pagination *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.getUrl('POST/nomina/empleados-plazas/pagination/show')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      val.page = 1
      this.params = val
      this.getUrl('POST/nomina/empleados-plazas/pagination/search/show')
      // this.pages = val
    },
    /* *==========*==========*==========*==========*==========* */

    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      // this.getUrl('POST/nomina/empleados-plazas/show')
      this.getUrl('POST/nomina/empleados-plazas/pagination/show')
    },
    newData (item) {
      this.view = null
      this.adquisicion = {}
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 800, title: 'ASIGNAR ADSCRIPCION' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    updateData ({ item }) {
      this.view = null
      this.form = this.get_updateAdscripcion
      this.form.map(field => {
        if (field.isHidden) {
          field.isHidden.map((item, i) => {
            this.form.map((form, index) => {
              if (item === form.nameid) {
                form.params = {}
                form.hidden = true
              }
            })
          })
        }
      })
      console.log('form', this.form)
      this.object = item
      this.url = this.get_urls['POST/nomina/empleados-plazas/store']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'update', with: 700, title: 'EDITAR ADSCRIPCION' })
    },
    toLowAdscripcion (item) {
      this.view = null
      this.adscripcion = item
      this.SHOW_DIALOG_MAIN({ type: 'lowAdscripcion', with: 500, title: 'BAJA DE ADSCRIPCION' })
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServicePaginationAction({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objectPagination', 'get_updateAdscripcion'])
  },
  watch: {
    get_urls () {
      // this.getUrl('POST/nomina/empleados-plazas/show')
      this.getUrl('POST/nomina/empleados-plazas/pagination/show')
    },
    get_objectPagination (val) {
      if (val) {
        this.tableServer.body.data = []
        this.tableServer.body.data = val.data
        this.tableServer.body.totalData = val.total
        this.tableServer.header.loading = false
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }

}
</script>

<style>

</style>
